import React from 'react';
import ReactDOM from 'react-dom';
import './ortho.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import KApp from './keycloakApp'
import { DEPLOYMENT_REGION } from './utils/constants';
import CApp from './cognitoApp'

ReactDOM.render(

  <Router>
    {DEPLOYMENT_REGION ==='USA'? <CApp/> : <KApp/>}
  </Router>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
